const FormatDate = (date, format) => {
  date = new Date(date);
  format = format.replace(/yyyy/g, date.getFullYear());
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
  format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
  format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
  return format;
};

const ValidateCompanyName = (companyName) => {
  return String(companyName)
    .toLowerCase()
    .match(
      /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/
    );
};

const ValidateTelNumber = (telNumber) => {
  return String(telNumber)
    .toLowerCase()
    .match(
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    );
};

const ValidateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const ValidatePersonName = (personName) => {
  const regPersonNameName = /^[a-zA-Z\u3400-\u9FBF ,.'-]+$/;
  return regPersonNameName.test(personName)
}

const ValidatePassword = (password) => {
  if (!password?.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,100})/)) {///^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,100})/
    return false;
  }
  return true;
}

const ValidatePhoneNumber = (phonenumber) => {
  if (!phonenumber?.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/)) {
    return false;
  }
  return true;
}

const IsEmptyString = (string) => {
  if (string === "") {
    return true;
  }
  return false;
}

const IsValidDirectoryName = (name) => {
  let regex = /^(?!\.)(?!com[0-9]$)(?!con$)(?!lpt[0-9]$)(?!nul$)(?!prn$)[^\|\*\?\\:<>/$"]*[^\.\|\*\?\\:<>/$"]+$/;
  // Must not be empty.
  // Must not start with .
  // Must not be com0-com9, con, lpt0-lpt9, nul, prn
  // Must not contain | * ? \ : < > $
  // Must not end with .
  return regex.test(name);
}

const IsObject = (str) => {
  try {
    if (typeof str === 'object') return true;
    if (
      typeof str === 'number' ||
      typeof str === 'boolean' ||
      str?.toString()?.search(/^[-]?\d+(\.\d+)?$/g) !== -1 ||
      str === undefined || 
      str === 'undefined'
    ) return false;
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export {
  FormatDate,
  ValidateCompanyName,
  ValidateTelNumber,
  ValidateEmail,
  ValidatePersonName,
  ValidatePassword,
  ValidatePhoneNumber,
  IsEmptyString,
  IsValidDirectoryName,
  IsObject,
}